import { useTranslation } from 'react-i18next';
import { allProducts } from '@/mocks/products';
import ProductCard from '@/components/base/ProductCard';
import { useNavigate } from 'react-router-dom';

const featuredIds = ['136312', '138084', '138192', '136582', '137556', '133386'];

export default function FeaturedProducts() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const featuredProducts = allProducts.filter(p => featuredIds.includes(p.id));

  return (
    <section className="px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
          {t('featured_products')}
        </h2>
        <p className="text-foreground-600 mb-8 md:mb-10">
          {t('featured_products_desc')}
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {featuredProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
        <div className="text-center mt-8 md:mt-10">
          <button
            onClick={() => navigate('/products')}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors cursor-pointer"
          >
            {t('all_products')}
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}